/* oxlint-disable @typescript-eslint/no-explicit-any */
import type { HTMLAttributes } from 'react';
import type {
  FieldValues,
  FormProviderProps,
  SubmitErrorHandler,
  SubmitHandler,
} from 'react-hook-form';
import { FormProvider } from 'react-hook-form';

export const Form = <TFieldValues extends FieldValues, TContext = any>(
  props: FormProviderProps<TFieldValues, TContext> & {
    onSubmit: SubmitHandler<TFieldValues>;
    onSubmitInvalid?: SubmitErrorHandler<TFieldValues>;
    id?: string;
    className?: string;
    rawProps?: HTMLAttributes<HTMLFormElement>;
  },
) => {
  const { children, onSubmit, onSubmitInvalid, rawProps = {}, ...form } = props;

  return (
    <FormProvider {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit, onSubmitInvalid)}
        {...rawProps}
        id={props.id ?? rawProps?.id}
        className={props.className ?? rawProps?.className}
      >
        {children}
      </form>
    </FormProvider>
  );
};
